import {mapActions, mapMutations, mapState} from "vuex";

export const loginMixin = {
    data() {
        let checkPwd = (rule, value, callback) => {
            if (value.trim().length === 0) {
                callback(new Error("请输入密码"));
            } else if (value !== this.formData.passwordOnce) {
                callback(new Error("两次密码输入不一致"));
            } else {
                callback();
            }
        };
        return {
            form1: {
                phone: "",
                password: "",
                passwordOnce: "",
                passwordTwice: "",
            },
            form2: {
                phone: "",
                captcha: "",
            },
            form1Rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: "请输入正确的手机号",
                        trigger: ["blur", "change"],
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                    {
                        pattern: /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9]{6,15}$/,
                        message: "请输入(6-15)位字母数字组合",
                        trigger: ["blur", "change"],
                    },
                ],
                passwordOnce: [
                    {
                        // required: true,
                        message: "请输入",
                        trigger: "blur",
                    },
                ],
                passwordTwice: [
                    {
                        validator: checkPwd,
                        // required: true,
                        trigger: "blur",
                    },
                ],
            },
            form2Rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: "请输入正确的手机号",
                        trigger: ["blur", "change"],
                    },
                ],
                captcha: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                ],
            },
            counter: 60,
            countingDown: false,
        };
    },
    computed: {
        ...mapState("tenant", ["tenantsList"]),
    },
    methods: {
        ...mapMutations("user", ["setData"]),
        ...mapActions("user", ["demoLogin", "login", "sendSms", "register"]),
        reduceCounter() {
            if (this.counter > 0) {
                setTimeout(() => {
                    this.counter -= 1;
                    this.reduceCounter();
                }, 1000);
            } else {
                this.resetCounter();
            }
        },
        startCounter() {
            this.countingDown = true;
            this.reduceCounter();
        },
        resetCounter() {
            this.countingDown = false;
            this.counter = 60;
        },
        async handleSendCode() {
            // await this.sendCode({
            //     mobile: this.formData.mobile,
            //     platform: this.platform,
            // })
            this.startCounter();
        },
        //发送验证码
        async getCaptcha() {
            if (this.countingDown) return;
            this.$refs.form2.validateField("phone", async (errorMsg) => {
                if (!errorMsg) {
                    try {
                        await this.sendSms({
                            phone: this.form2.phone,
                        });
                        this.startCounter();
                        this.$message.success("验证码发送成功，请查看手机短信");
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
        clearForm() {
            Object.keys(this.form1).map((key) => {
                this.formData[key] = null;
            });
            Object.keys(this.form2).map((key) => {
                this.formData[key] = null;
            });
            this.counter = 60;
            this.countingDown = false;
        },
        //密码登录
        async handleLoginOnWord() {
            this.$refs.form1.validate(async (valid) => {
                if (valid) {
                    await this.loginInit(this.form1.phone, this.form1.password, null, this.authUnionId);
                }
            });
        },
        //验证码登录
        async handleLoginOnCode() {
            this.$refs.form2.validate(async (valid) => {
                if (valid) {
                    await this.loginInit(this.form2.phone, null, this.form2.captcha, this.authUnionId);
                }
            });
        },
        async tenantRegisterHandle() {
            await this.$router.push({name: "Register"})
        },
        async loginInit(phone, password, captcha, authUnionId) {
            await this.login({
                phone: phone,
                captcha: captcha,
                password: password,
                authUnionId: authUnionId,
            });
            localStorage.removeItem("userId");
            await this.$router.push({name: "Init"});
        },
        //用户注册
        async handleRegister() {
            if (!this.formData.checked) {
                this.$message({
                    message: "未勾选注册协议",
                    type: "warning",
                });
                return;
            }
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    await this.register({
                        phone: this.formData.phone,
                        password: this.formData.passwordOnce,
                        captcha: this.formData.captcha,
                    });
                    await this.$router.push({name: "Index",}
                    );
                }
            });
        },
        // goHome() {
        //     this.$router.push('/')
        // },
    },
};
